import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

// @mui/icons-material
import MenuIcon from '@mui/icons-material/Menu';
import Fingerprint from '@mui/icons-material/Fingerprint';

// core components
import Button from '../md/components/CustomButtons/Button';

import plainNavbarStyle from '../assets/jss/crm/components/plainNavbarStyle.jsx';

class PlainNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }
  handleDrawerToggle = () => {
    this.setState({ open: !this.state.open });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.setState({ open: false });
    }
  }
  render() {
    const { classes, color, brandText } = this.props;
    const hideFingerprintLoginPrompt = true; // preserving the code but hiding its effect
    const appBarClasses = cx({
      [' ' + classes[color]]: color,
    });
    const list =
      hideFingerprintLoginPrompt || brandText === 'Login' ? null : (
        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <NavLink
              to={'/p/login'}
              className={cx(classes.navLink, {
                [classes.navLinkActive]: this.activeRoute('/p/login'),
              })}
            >
              <Fingerprint className={classes.listItemIcon} />
              <ListItemText primary={'Login'} disableTypography={true} className={classes.listItemText} />
            </NavLink>
          </ListItem>
        </List>
      );
    return (
      <AppBar position="static" className={classes.appBar + appBarClasses}>
        <Toolbar className={classes.container}>
          <Box className={classes.flex} component="div" sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Button className={classes.title} color="transparent">
              {brandText}
            </Button>
          </Box>
          <Box className={classes.flex} component="div" sx={{ display: { xs: 'block', sm: 'none' } }}>
            <Button className={classes.title} color="transparent">
              Alleva CRM
            </Button>
          </Box>
          <Box component="div" sx={{ display: { md: 'block', xs: 'none' } }}>
            {list}
          </Box>
          <Button
            sx={{ display: { md: 'none', xs: 'block' } }}
            className={classes.sidebarButton}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={this.handleDrawerToggle}
          >
            <MenuIcon />
          </Button>
          <Drawer
            sx={{ display: { md: 'none', xs: 'block' } }}
            variant="temporary"
            anchor={'right'}
            open={this.state.open}
            classes={{
              paper: classes.drawerPaper,
            }}
            onClose={this.handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {list}
          </Drawer>
        </Toolbar>
      </AppBar>
    );
  }
}

PlainNavbar.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  brandText: PropTypes.string,
};

export default withStyles(plainNavbarStyle)(PlainNavbar);
